export const GET_ASPIRE_SYNC_LOGS_START = 'GET_ASPIRE_SYNC_LOGS_START';
export const GET_ASPIRE_SYNC_LOGS_SUCCESS = 'GET_ASPIRE_SYNC_LOGS_SUCCESS';
export const GET_ASPIRE_SYNC_LOGS_FAILED = 'GET_ASPIRE_SYNC_LOGS_FAILED';

export const GET_TOUCHMD_SYNC_LOGS_START = 'GET_TOUCHMD_SYNC_LOGS_START';
export const GET_TOUCHMD_SYNC_LOGS_SUCCESS = 'GET_TOUCHMD_SYNC_LOGS_SUCCESS';
export const GET_TOUCHMD_SYNC_LOGS_FAILED = 'GET_TOUCHMD_SYNC_LOGS_FAILED';

export const GET_MODMED_SYNC_LOGS_START = 'GET_MODMED_SYNC_LOGS_START';
export const GET_MODMED_SYNC_LOGS_SUCCESS = 'GET_MODMED_SYNC_LOGS_SUCCESS';
export const GET_MODMED_SYNC_LOGS_FAILED = 'GET_MODMED_SYNC_LOGS_FAILED';

export const GET_RPA_SYNC_LOGS_START = 'GET_RPA_SYNC_LOGS_START';
export const GET_RPA_SYNC_LOGS_SUCCESS = 'GET_RPA_SYNC_LOGS_SUCCESS';
export const GET_RPA_SYNC_LOGS_FAILED = 'GET_RPA_SYNC_LOGS_FAILED';

export const ADD_ASPIRE_LOG = 'ADD_ASPIRE_LOG';
export const ADD_MODMED_LOG = 'ADD_MODMED_LOG';
export const ADD_TOUCHMD_LOG = 'ADD_TOUCHMD_LOG';
export const ADD_RPA_LOG = 'ADD_RPA_LOG';

export const getAspireSyncLogsStart = () => ({
  type: GET_ASPIRE_SYNC_LOGS_START
});

export const getAspireSyncLogsSuccess = (data) => ({
  type: GET_ASPIRE_SYNC_LOGS_SUCCESS,
  data
});

export const getAspireSyncLogsFailed = (error) => ({
  type: GET_ASPIRE_SYNC_LOGS_FAILED,
  error
});

export const getTouchMDSyncLogsStart = () => ({
  type: GET_TOUCHMD_SYNC_LOGS_START
});

export const getTouchMDSyncLogsSuccess = (data) => ({
  type: GET_TOUCHMD_SYNC_LOGS_SUCCESS,
  data
});

export const getTouchMDSyncLogsFailed = (error) => ({
  type: GET_TOUCHMD_SYNC_LOGS_FAILED,
  error
});

export const getModMedSyncLogsStart = () => ({
  type: GET_MODMED_SYNC_LOGS_START
});

export const getModMedSyncLogsSuccess = (data) => ({
  type: GET_MODMED_SYNC_LOGS_SUCCESS,
  data
});

export const getModMedSyncLogsFailed = (error) => ({
  type: GET_MODMED_SYNC_LOGS_FAILED,
  error
});

export const getRpaSyncLogsStart = () => ({
  type: GET_RPA_SYNC_LOGS_START
});

export const getRpaSyncLogsSuccess = (data) => ({
  type: GET_RPA_SYNC_LOGS_SUCCESS,
  data
});

export const getRpaSyncLogsFailed = (error) => ({
  type: GET_RPA_SYNC_LOGS_FAILED,
  error
});

export const addAspireLog = (data) => ({
  type: ADD_ASPIRE_LOG,
  data
});

export const addTouchMDLog = (data) => ({
  type: ADD_TOUCHMD_LOG,
  data
});

export const addModMedLog = (data) => ({
  type: ADD_MODMED_LOG,
  data
});

export const addRpaLog = (data) => ({
  type: ADD_RPA_LOG,
  data
});
